import React, { ComponentProps as CP } from 'react'
import classNames from 'classnames'

import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles'

import T from 'components/FormattedMessage'
import Button from 'components/Button'

const styles = createStyles({
  root: {
    textAlign: 'center',
  }
})

type InjectedProps = CP<typeof Button> & WithStyles<typeof styles> & {
  target?: '_blank' | '_self' | '_parent' | '_top' | undefined
}

const FacebookButton: React.SFC<InjectedProps> = ({ classes, className, ...props }) => {
  return (
    <Button className={classNames(className, classes.root)} {...props}>
      <T id="account_action_facebookpagebutton" />
    </Button>
  )
}

FacebookButton.defaultProps = {
  href: 'https://www.facebook.com/Foosio.Official',
  color: 'facebook',
  target: '_blank',
  variant: 'contained',
}

export default withStyles(styles)(FacebookButton)
